import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { makeGetVehicleModuleLogicCount } from 'selectors/truck'
import ModuleSummary from './ModuleSummary'

const makeMapStateToProps = () => {
  const getVehicleModuleLogicCount = makeGetVehicleModuleLogicCount()

  const mapStateToProps = (state, ownProps) => {
    const { moduleName, serialNumber } = ownProps

    const {
      logicCount,
      maxLogics,
      timerCount,
      maxTimers,
      pinCount,
      maxPins,
      variant,
      canInputsCount,
      maxCanInputs,
      maxSwitchIndicators,
      switchIndicatorCount,
    } = getVehicleModuleLogicCount(state, { moduleName, serialNumber })

    return {
      moduleName,
      logicCount,
      maxLogics,
      timerCount,
      maxTimers,
      pinCount,
      maxPins,
      variant,
      maxCanInputs,
      canInputsCount,
      ...(maxSwitchIndicators && switchIndicatorCount
        ? {
            maxSwitchIndicators,
            switchIndicatorCount,
          }
        : {}),
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { serialNumber, moduleName } = ownProps
  return {
    goToEcu: () =>
      dispatch(push(`/vehicles/${serialNumber}/ecus/${moduleName}`)),
  }
}

const ChecPlusVehicleModuleSummaryContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(ModuleSummary)

export default ChecPlusVehicleModuleSummaryContainer
